import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calculator-type',
  templateUrl: './calculator-type.component.html',
  styleUrls: ['./calculator-type.component.scss'],
})
export class CalculatorTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
